import React, { useState, useEffect } from "react";

import CardsOptions from "./CardsOptions";
import CardOptions from "./CardOptions";
import LinkSidebarTransition from "@Shared/Components/LinkSidebar";
import { IconsSidebar, ImagePicker } from "@caelor/ui";
import { CARDS_PROP, getIconOptions } from "./defaults";
import { useCardsStore } from "../../../../../../stores/use-cards-store";
import {
  styleguideService,
  styleguidePropertyKeys,
} from "@Shared/Service/StyleguideService";
import { useTranslation } from "react-i18next";
import { ImageFocalPoint } from "@lemoncode/react-image-focal-point";

const CardsSettings = () => {
  const [searchValue, setSearchValue] = useState(false);
  const [appIcons, setAppIcons] = useState(false);

  const { t } = useTranslation();

  const { data, card, action, setAction, updateCardData } = useCardsStore(
    (state) => ({
      data: state.data,
      card: state.card,
      action: state.action,
      setAction: state.setAction,
      updateCardData: state.updateCardData,
    })
  );

  const selectedCard = data.reduce(
    (acc, { card }) => (card.id === action?.card?.card?.id ? card : acc),
    {}
  );

  useEffect(() => {
    styleguideService
      .getProperty(styleguidePropertyKeys.APP_ICONS)
      .then((response) => response && setAppIcons(response.data || []))
      .catch((e) => console.log(e));
  }, []);

  const CardsSettingsComponent = card ? CardOptions : CardsOptions;
  const isEmoji = action && typeof action.card.card.icon === "object";

  const updateIcon = (value) => {
    updateCardData({
      id: selectedCard.id,
      key: CARDS_PROP.ICON,
      value,
    });
    setAction(undefined);
  };

  const ICON_OPTIONS = getIconOptions(t);

  return (
    <>
      {action && action.drawer === "link" && (
        <LinkSidebarTransition
          isOpen={action.drawer === "link"}
          setIsOpen={() => setAction(undefined)}
          value={selectedCard.link}
          onChange={(value) => {
            updateCardData({
              id: selectedCard.id,
              key: CARDS_PROP.LINK,
              value,
            });
            setAction(undefined);
          }}
        />
      )}

      {action && action.drawer === "icon" && (
        <IconsSidebar
          appIcons={appIcons}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          isOpen={action.drawer === "icon"}
          setIsOpen={() => setAction(undefined)}
          containerStyles={{ top: "75px" }}
          onEmojiChange={updateIcon}
          onIconChange={updateIcon}
          onAppChange={updateIcon}
          selectedIcon={isEmoji ? selectedCard.icon?.value : selectedCard?.icon}
          tabs={
            ICON_OPTIONS[action.card.config.design] || [
              t("icons"),
              t("emojis"),
              t("logos"),
            ]
          }
          activeTab={t(isEmoji ? "emojis" : "icons")}
        />
      )}

      {action && action.drawer === "image" && (
        <ImagePicker
          asParent={false}
          image={selectedCard.image || {}}
          hideCurrentPage={false}
          open={action.drawer === "image"}
          setOpen={() => {}}
          onClose={() => setAction(undefined)}
          onChange={(value) => {
            updateCardData({
              id: selectedCard.id,
              key: CARDS_PROP.IMAGE,
              value,
            });

            if (value.source !== "link") {
              setAction(undefined);
            }
          }}
          imageReposition={true}
          ImageRepositionComponent={ImageFocalPoint}
          tabs={["Unsplash", "From page", "Link", "Upload"]}
          sidebarContainerStyles={{}}
          thumbnailContainerStyles={{}}
          libraryImages={[]}
          iconLibraryImages={[]}
          hideInfo={true}
        />
      )}

      {!action && <CardsSettingsComponent />}
    </>
  );
};

export default CardsSettings;
